import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

const TdlOverlay = {
  name: "tdl-overlay"
};

const __vue_script__ = TdlOverlay;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tdl-overlay"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-59971886_0", {
    source: ".tdl-overlay{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
